const routes = [
    {
        path: "/my-profile",
        component: () => import("../pages/student/MyProfile"),
        meta: {
            isAuthenticated: true,
            isStudent: true
        },
        component_full_path: 'students/pages/student/MyProfile'
    },
    {
        path: "/my-course-schedule",
        component: () => import("../pages/student/MyCourseSchedule"),
        meta: {
            isAuthenticated: true,
            isStudent: true
        },
        // component_full_path: 'my-course-schedule/pages/student/MyCourseSchedule'
    },
    {
        path: "/my-courses",
        component: () => import("../pages/student/MyCourses"),
        meta: {
            isAuthenticated: true,
            isStudent: true,
            isMyCourses:true
        },
        // component_full_path: 'my-courses/pages/student/MyCourses'
    },
    {
        path: "/show-document",
        component: () => import("../pages/student/showDocuments.vue"),
        meta: {
            isAuthenticated: true,
            isStudent: true,
        },
        // component_full_path: 'my-courses/pages/student/MyCourses'
    },
    {
        path: "/students",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "student_index"
        },
        component_full_path: 'students/pages/Index'
    },
    {
        path: "/students/:id",
        component: () => import("../pages/student/Index"),
        meta: {
            isAuthenticated: true,
            permission: "student_show"
        },
        component_full_path: 'students/pages/student/Index'
    },
    {
        path: "/students/calculate/gpa",
        component: () => import("../pages/CalculateGpa"),
        meta: {
            isAuthenticated: true,
            permission: "student_calculategpa"
        },
        // component_full_path: 'students/pages/CalculateGpa'
    },
];

export default routes;
